// Top KPI cards for the Admin dashboard (reference design).
import React from "react";
import { currency } from "./dashboardShared";

export default function StatsCards({ dash, totalUsers, totalOrders }) {
  const us = dash?.userStats || {};
  const os = dash?.orderStats || {};

  const pending = Number(os.pending || 0);
  const inProgress =
    Number(os.sales_executive_assigned || 0) +
    Number(os.design_received || 0) +
    Number(os.quotation_received || 0) +
    Number(os.order_tracking || 0);
  const orderTotal = pending + inProgress || 1;
  const pendingPct = Math.round((pending / orderTotal) * 100);
  const progressPct = 100 - pendingPct;

  const newUsers = Number(dash?.recentActivity?.newUsers || 0);

  return (
    <section className="section">
      <div className="grid grid--four">
        {/* Total Users */}
        <div className="card card--hover stat-card">
          <div className="stat-card__top">
            <span className="stat-card__title">Total Users</span>
            <div
              className="stat-card__icon"
              style={{
                color: "var(--color-primary)",
                background: "var(--color-primary-weak)",
              }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
          </div>
          <div className="stat-card__row">
            <span className="stat-card__value">{totalUsers}</span>
            {newUsers > 0 && (
              <span className="stat-card__delta stat-card__delta--up">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="18 15 12 9 6 15" />
                </svg>
                +{newUsers}
              </span>
            )}
          </div>
          <div className="stat-card__tags">
            <span className="stat-tag">Admin {us.admin || 0}</span>
            <span className="stat-tag">Subadmin {us.subadmin || 0}</span>
            <span className="stat-tag">Supplier {us.supplier || 0}</span>
            <span className="stat-tag">Buyer {us.buyer || 0}</span>
          </div>
        </div>

        {/* Total Orders */}
        <div className="card card--hover stat-card">
          <div className="stat-card__top">
            <span className="stat-card__title">Total Orders</span>
            <div
              className="stat-card__icon"
              style={{
                color: "var(--color-info-text)",
                background: "var(--color-info-bg)",
              }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
            </div>
          </div>
          <div className="stat-card__row">
            <span className="stat-card__value">{totalOrders}</span>
            <span className="stat-card__hint">total</span>
          </div>
          <div className="stat-bar">
            <span style={{ width: `${pendingPct}%`, background: "var(--c-amber)" }} />
            <span style={{ width: `${progressPct}%`, background: "var(--c-blue)" }} />
          </div>
          <div className="stat-legend">
            <span>
              <i style={{ background: "var(--c-amber)" }} />
              Pending {pending}
            </span>
            <span>
              <i style={{ background: "var(--c-blue)" }} />
              In-progress {inProgress}
            </span>
          </div>
        </div>

        {/* Active Products */}
        <div className="card card--hover stat-card">
          <div className="stat-card__top">
            <span className="stat-card__title">Active Products</span>
            <div
              className="stat-card__icon"
              style={{
                color: "var(--color-success-text)",
                background: "var(--color-success-bg)",
              }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <line x1="7" y1="7" x2="7.01" y2="7" />
              </svg>
            </div>
          </div>
          <div className="stat-card__row">
            <span className="stat-card__value">{dash?.productStats?.active || 0}</span>
            <span className="stat-card__hint">catalog health</span>
          </div>
          <div style={{ marginTop: 13 }}>
            <span
              className="stat-pill"
              style={{
                color: "var(--color-success-text)",
                background: "var(--color-success-bg)",
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              All published
            </span>
          </div>
        </div>

        {/* Total Revenue */}
        <div className="card card--hover stat-card">
          <div className="stat-card__top">
            <span className="stat-card__title">Total Revenue</span>
            <div
              className="stat-card__icon"
              style={{
                color: "var(--color-violet-text)",
                background: "var(--color-violet-bg)",
              }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
          </div>
          <div className="stat-card__row">
            <span className="stat-card__value">{currency(dash?.totalRevenue || 0)}</span>
          </div>
          <p className="stat-card__note">
            From completed orders.{" "}
            {Number(dash?.totalRevenue || 0) === 0 && (
              <span style={{ color: "var(--color-primary)", fontWeight: 700 }}>
                Awaiting first close →
              </span>
            )}
          </p>
        </div>
      </div>
    </section>
  );
}
